import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedComponentsModule } from '../shared-components.module';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-request-verification-code-popup',
  standalone: true,
  imports: [CommonModule, SharedComponentsModule],
  templateUrl: './request-verification-code-popup.component.html',
  styleUrls: ['./request-verification-code-popup.component.scss']
})
export class RequestVerificationCodePopupComponent implements OnInit {
  readonly _dialog: MatDialogRef<RequestVerificationCodePopupComponent> = inject(
    MatDialogRef<RequestVerificationCodePopupComponent>
  );
  private readonly data: any = inject(MAT_DIALOG_DATA);

  confirmAction: (phone: string | null) => void;
  cancelAction: () => void;

  ngOnInit(): void {
    if (this.data) {
      this.confirmAction = this.data?.confirmAction || null;
      this.cancelAction = this.data?.cancelAction || null;
    }
  }

  verificationCode: FormControl = new FormControl(null, [
    Validators.required,
    Validators.minLength(6),
    Validators.maxLength(6)
  ]);

  closeDialog() {
    if (this.cancelAction) {
      this.cancelAction();
    } else {
      this.confirmAction(null);
    }

    this._dialog.close();
  }

  proceed() {
    this.confirmAction(this.verificationCode.value);
    this._dialog.close();
  }
}
